#import "./ContractFields.graphql"

mutation RecordContractRenewalDecision(
  $id: ID!
  $decision: ContractRenewalDecisionEnum
  $decidedOn: ISO8601Date
) {
  recordContractRenewalDecision(
    input: { id: $id, decision: $decision, decidedOn: $decidedOn }
  ) {
    contract {
      ...ContractFields
    }
  }
}
